



















import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { SavePacsData } from "@/api/hd";
@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {};
  Url = XMLHTTP_BASEURL;
  imageUrlList: any = [];
  imageUrl = "";
  imageIndex = 1;
  imageSize = 100;
  maxlength = 0;
  created() {
    this.form = Object.assign({}, this.data);
    if (this.form.mirrorUnder) {
      this.imageUrlList = this.form.mirrorUnder.split(";");
      this.maxlength = this.imageUrlList.length;
    }
  }
  rules = {};
  next() {
    if (this.imageIndex + 1 > this.maxlength) {
      this.imageIndex = 1;
    } else {
      this.imageIndex++;
    }
  }
  previous() {
    if (this.imageIndex <= 1) {
      this.imageIndex = this.maxlength;
    } else {
      this.imageIndex--;
    }
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/parts/pathologicdiagnosis/imagePathology.vue